<script lang="ts">
    import translations from '../../translations';
    import { base } from '$app/paths';

    // Types
    import type { Language } from '$lib/types/Language';

    export let language: Language = 'de';

    const url = `${base}/consent-policy#cookielist`;
</script>

<span>
    <a href={url} class="underline hover:text-gray-900">{translations[language].here}</a>
    {translations[language].additionalDesc}
</span>
